import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aij_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err.config?.url || "";
    // Business-validation 401 endpoints should NOT force-logout
    const isBusinessAuth =
      url.includes("/auth/change-code") || url.includes("/auth/login");
    if (err.response?.status === 401 && !isBusinessAuth) {
      localStorage.removeItem("aij_token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const ASSOC = {
  name: "ACTION IMPACT JEUNESSE",
  logo: "https://customer-assets.emergentagent.com/job_0233820f-1364-4d66-83e8-80e343bbfaff/artifacts/oxpkfugr_Action%20Impact%20Jeunesse%20%283%29.png",
  address: "10 rue Jean-François Champollion, 85000 La Roche-sur-Yon",
  email: "actionimpactjeunesse@gmail.com",
  website: "www.actionimpactjeunesse.com",
  phones: ["06 95 62 29 53", "06 18 81 51 32", "06 75 89 90 41"],
};

export const eur = (v) =>
  new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 2,
  }).format(Number(v || 0));

export const frDate = (iso) => {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleDateString("fr-FR");
  } catch {
    return iso;
  }
};

export async function downloadPdf(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const contentType = res.headers["content-type"] || "application/octet-stream";
  const url = window.URL.createObjectURL(new Blob([res.data], { type: contentType }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export async function openPdf(path) {
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  window.open(url, "_blank");
}
